import {
  Spinner,
  Alert,
  Container,
  Navbar,
  Nav,
  Button,
  Row,
  Col,
  Modal,
} from "react-bootstrap";

import DOMPurify from "dompurify";

import {
  ExclamationTriangleFill,
  InfoCircleFill,
  XCircleFill,
} from "react-bootstrap-icons";

let logInfoDebug = null;

export function cadenaFechaADate(cadenaFecha) {
  const [dia, mes, annio] = cadenaFecha.split("-").map(Number);
  return new Date(annio, mes - 1, dia); // month is 0-based!
}

export const excepcionVacia = {
  excepcionConocida: null,
  tipoExcepcion: null,
  codigoExcepcion: null,
  tituloExcepcion: null,
  mensajeExcepcion: null,
  permitirReiniciarProceso: false,
  continuarEnPagina: false,
  infoDebug: null,
};

export const Cabecera = (props) => {
  return (
    <Navbar bg="light" expand="lg" className="shadow-sm">
      <Container>
        <Navbar.Brand>
          <img
            src={
              process.env.PUBLIC_URL +
              "/" +
              props.config.tenant +
              "/img/logo_cabecera.png"
            }
            alt="Logo"
            className="img-fluid me-2"
            style={{ maxHeight: "40px" }}
          />
        </Navbar.Brand>
        {props.config.urlPaginaWeb ? (
          <Nav className="ms-auto">
            <Nav.Link href={props.config.urlPaginaWeb} target="_blank" rel="noopener noreferrer">
              Visita nuestra web
            </Nav.Link>
          </Nav>
        ) : (
          ""
        )}
      </Container>
    </Navbar>
  );
};

export const Pie = (props) => {
  return (
    <footer className="bg-secondary text-white text-center py-2 mt-auto footer-text">
      <b>
        ©{props.config.annioCopyright}-{new Date().getFullYear()}{" "}
        {props.config.nombreCliente}
      </b>
      . Todos los derechos reservados.
    </footer>
  );
};

export const Titulo = (props) => {
  return <h4 className="mt-3 mb-3 text-center px-3">{props.textoTitulo}</h4>;
};

export const Cargando = (props) => {
  return (
    <Modal
      show={props.visible !== false}
      backdrop="static" // prevent closing by clicking outside
      keyboard={false} // prevent ESC key close
      centered
      size="sm"
      contentClassName="text-center"
    >
      <Modal.Body className="py-5">
        <Spinner animation="border" role="status" className="mb-3" />
        <div>{props.mensaje}</div>
      </Modal.Body>
    </Modal>
  );
};

export const quitarCcParam = () => {
  const url = new URL(window.location);
  url.searchParams.delete("cc");
  window.history.replaceState({}, "", url);
};

export function initLogger(config) {
  logInfoDebug = config.mostrarInfoDebug;
}

export function logger(texto){
  if (logInfoDebug)
  {
    const ahora = new Date();

    const dd = String(ahora.getDate()).padStart(2, '0');
    const mm = String(ahora.getMonth() + 1).padStart(2, '0'); // enero = 0
    const yyyy = ahora.getFullYear();

    const hh = String(ahora.getHours()).padStart(2, '0');
    const min = String(ahora.getMinutes()).padStart(2, '0');
    const ss = String(ahora.getSeconds()).padStart(2, '0');

    const fechaHora = `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;

    console.log(fechaHora + " : " + texto);
  }
}

export function normalizeError(error, mostrarInfoDebug) {
  const mensajeErrorDesconocido =
    "Lo sentimos, se ha producido un error al llevar a cabo la operaci&oacute;n. Por favor, ponte en contacto con nosotros por tel&eacute;fono para solicitar tu cita";

  if (!error || typeof error !== "object") {
    // If it’s a string, number, or null/undefined
    logger("en el noremalize, voy por deonde no es objeto");
    return {
      ...excepcionVacia,
      tipoExcepcion: "E",
      excepcionConocida: 0,
      mensajeExcepcion: mostrarInfoDebug
        ? String(error) || "Error desconocido"
        : mensajeErrorDesconocido,
    };
  } else {
    if (Object.hasOwn(error, "excepcionConocida")) {
      return error;
    } else {
      return {
        ...excepcionVacia,
        excepcionConocida: 0,
        tipoExcepcion: "E",
        mensajeExcepcion: mostrarInfoDebug
          ? "Error: " + error.message
          : mensajeErrorDesconocido,
        permitirReiniciarProceso: 1,
        continuarEnPagina: 0,
        infoDebug: mostrarInfoDebug ? error.stack : null,
      };
    }
  }

  /* Merge thrown object with defaultApiError to ensure all fields exist
  return {
    ...excepcionVacia,
    ...error,
    mensaje: error.message || excepcionVacia.mensaje,
    infoDebug: error.stack || JSON.stringify(error),
  };*/
}

export const MensajeExcepcion = (props) => {
  // Choose icon and color based on type
  const getTipoAlert = () => {
    switch (props.tipo) {
      case "E":
        return "danger";
      case "W":
        return "warning";
      default:
        return "info";
    }
  };

  const mensajeSanitizado = {
    __html: DOMPurify.sanitize(props.mensaje, { USE_PROFILES: { html: true } }),
  };

  return (
    <Container className="pt-3">
      <Alert
        variant={getTipoAlert()}
        className="shadow-sm"
        dismissible={props.permitirCerrar !== false}
        onClose={() => props.setExcepcion(null)}
        ref={props.alertRef}
      >
        <Alert.Heading>{props.titulo}</Alert.Heading>
        <p dangerouslySetInnerHTML={mensajeSanitizado}></p>
        {props.mostrarInfoDebug && props.infoDebug ? (
          <>
            <br />
            <br />
            <p>{props.infoDebug}</p>
          </>
        ) : (
          ""
        )}
      </Alert>
    </Container>
  );
};

export const MensajeFinal = (props) => {
  // Choose icon and color based on type
  const getIcon = () => {
    switch (props.tipo) {
      case "E":
        return <XCircleFill size={48} />;
      case "W":
        return <ExclamationTriangleFill size={48} />;
      default:
        return <InfoCircleFill size={48} />;
    }
  };

  const handleClickReiniciarProceso = () => {
    props.reiniciarProceso();
  };

  if (props.permitirReiniciarProceso) {
    props.limpiarSesion();
  }

  const mensajeSanitizado = {
    __html: DOMPurify.sanitize(props.mensaje, { USE_PROFILES: { html: true } }),
  };

  return (
    <Container className="flex-grow-1 d-flex align-items-center justify-content-center py-5">
      <Row>
        <Col className="text-center p-4">
          <div className="mb-4" size={48}>
            {getIcon()}
          </div>
          {props.titulo && <h3 className="mb-5">{props.titulo}</h3>}
          <div
            className="mb-4"
            dangerouslySetInnerHTML={mensajeSanitizado}
          ></div>
          {props.mostrarInfoDebug &&
          props.infoDebug &&
          props.infoDebug !== null ? (
            <div className="my-3">{props.infoDebug}</div>
          ) : (
            ""
          )}
          {props.permitirReiniciarProceso ? (
            <Button variant="primary" onClick={handleClickReiniciarProceso}>
              Reiniciar el proceso
            </Button>
          ) : (
            ""
          )}
        </Col>
      </Row>
    </Container>
  );
};

export async function llamarApi({
  url,
  jwt,
  method,
  payload,
  onSuccess,
  onError,
  onFinally,
}) {
  try {
    let urlCompleta = url;
    let options = { method };

    if (method.toUpperCase() === "GET") {
      if (jwt) {
        options.headers = { Authorization: `Bearer ${jwt}` };
      }

      if (payload) {
        const query = new URLSearchParams(payload).toString();
        urlCompleta += `?${query}`;
      }
    } else if (payload) {
      options.headers = {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${jwt}`,
      };
      options.body = JSON.stringify(payload);
    }

    const response = await fetch(urlCompleta, options);

    if (!response.ok) {
      const errorData = await response.json();

      if (Object.hasOwn(errorData, "excepcionConocida")) {
        logger(
          "es un error en el body con excpecionconocida:" +
            JSON.stringify(errorData)
        );
        throw errorData;
      } else {
        throw {
          ...excepcionVacia,
          excepcionConocida: false,
          tipoExcepcion: "E",
          codigoExcepcion: null,
          tituloExcepcion: null,
          mensajeExcepcion: errorData?.error,
          permitirReiniciarProceso: true,
          continuarEnPagina: false,
          infoDebug: errorData,
        };
      }
    }

    const data = await response.json();

    if (data.operacionCorrecta === 1) {
      onSuccess(data);
    } else {
      logger("error conocido:" + JSON.stringify(data));
      throw {
        ...excepcionVacia,
        errorConocido: 1,
        tipoExcepcion: data.tipoExcepcion,
        codigoExcepcion: data.codigoExcepcion,
        tituloExcepcion: data.tituloExcepcion,
        mensajeExcepcion: data.mensajeExcepcion,
        permitirReiniciarProceso: data.permitirReiniciarProceso,
        continuarEnPagina: data.continuarEnPagina,
        infoDebug: null,
      };
    }
  } catch (error) {
    const excepcionNormalizada = normalizeError(error);
    if (onError) onError(excepcionNormalizada);
  } finally {
    if (onFinally) onFinally();
  }
}